/** @format */

import { simCardActions, simCardConstants } from '../modules/simcard/actions';
import { FormGeneralHelper } from './FormGeneral';
import { Auth, tokenInfo } from '../modules/auth/Auth';

export const plkLimitPremiumMap = {
    'hydra:member': [
        { id: 1, name: 'simcard:f.sms_and_blockade' },
        { id: 0, name: 'simcard:f.sms' },
    ],
};

export const plkLimitPremiumAmount = {
    'hydra:member': [
        { id: '0', name: '0 PLN' },
        { id: '35', name: '35 PLN' },
        { id: '50', name: '50 PLN' },
        { id: '100', name: '100 PLN' },
        { id: '200', name: '200 PLN' },
    ],
};

export class SimCardOperationHelper {
    static isMvnoActive = (simCard) => {
        if (Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN_EXPERT || Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_PARTNER_EXPERT) {
            return true;
        }
        return true;
        //const status = simCard.mvnoStatus;
        //return status === 2 || status === 3;
    };

    static getUri = (simCard) => {
        return {
            uri: simCard['@id'],
            simCardId: simCard.id,
        };
    };

    static synchronizeCallback = (param, dispatch) => {
        dispatch(
            simCardActions.post(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_synchronizes')),
                param,
                simCardConstants.D_SIM_CARD_SYNCHRONIZE_SERVICES
            )
        );
    };

    static isFullyActive = (simCard) => {
        if (Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN_EXPERT || Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_PARTNER_EXPERT) {
            return true;
        }
        if (simCard && simCard.iccidStatus === '-1') {
            return false;
        }
        return simCard && simCard.active && !simCard.deleted;
    };

    static isNotSendActivationRequest = (simCard) => {
        if (Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN_EXPERT || Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_PARTNER_EXPERT) {
            return true;
        }
        if (simCard.active === false && simCard.isOrdersPending === false) {
            return true;
        }
        return false;
    };

    static getSimCardFupStatus = (simCard) => {
        switch (simCard.fupState) {
            case 1:
                return 'simcard:list.green';
            case 2:
                return 'simcard:list.yellow';
            case 3:
                return 'simcard:list.red';
            default:
                return 'simcard:list.undefined';
        }
    };
    static getSimCardStatus = (simCard) => {
        if (simCard.deleted) {
            return 'simcard:list.deleted';
        }
        if (simCard.mvnoStatus === 1) {
            return 'simcard:list.preactive';
        }
        if (SimCardOperationHelper.isFullyActive(simCard) && simCard.removePeriod) {
            return 'simcard:list.wait_for_remove';
        }
        if (SimCardOperationHelper.isFullyActive(simCard)) {
            return 'simcard:list.active';
        }
        return 'simcard:list.undefined';
    };
}
